import { Pais } from './../../models/shareds/Pais'

// Gerado a partir do enum Pais.java do backend (tabela de paises da Receita).
// O valor enviado ao backend e o 'nome', que e o name() da constante do enum.
const paises: Pais[] = [
	{ nome: 'AFEGANISTAO', codigo: '132', descricao: 'AFEGANISTAO' },
	{ nome: 'AFRICA_DO_SUL', codigo: '7560', descricao: 'AFRICA DO SUL' },
	{ nome: 'ALAND_ILHAS', codigo: '153', descricao: 'ALAND, ILHAS' },
	{ nome: 'ALBANIA_REPUBLICA_DA', codigo: '175', descricao: 'ALBANIA, REPUBLICA  DA' },
	{ nome: 'ALEMANHA', codigo: '230', descricao: 'ALEMANHA' },
	{ nome: 'ANDORRA', codigo: '370', descricao: 'ANDORRA' },
	{ nome: 'ANGOLA', codigo: '400', descricao: 'ANGOLA' },
	{ nome: 'ANGUILLA', codigo: '418', descricao: 'ANGUILLA' },
	{ nome: 'ANTARTICA', codigo: '420', descricao: 'ANTARTICA' },
	{ nome: 'ANTIGUA_E_BARBUDA', codigo: '434', descricao: 'ANTIGUA E BARBUDA' },
	{ nome: 'ANTILHAS_HOLANDESAS', codigo: '477', descricao: 'ANTILHAS HOLANDESAS' },
	{ nome: 'ARABIA_SAUDITA', codigo: '531', descricao: 'ARABIA SAUDITA' },
	{ nome: 'ARGELIA', codigo: '590', descricao: 'ARGELIA' },
	{ nome: 'ARGENTINA', codigo: '639', descricao: 'ARGENTINA' },
	{ nome: 'ARMENIA_REPUBLICA_DA', codigo: '647', descricao: 'ARMENIA, REPUBLICA DA' },
	{ nome: 'ARUBA', codigo: '655', descricao: 'ARUBA' },
	{ nome: 'AUSTRALIA', codigo: '698', descricao: 'AUSTRALIA' },
	{ nome: 'AUSTRIA', codigo: '728', descricao: 'AUSTRIA' },
	{ nome: 'AZERBAIJAO_REPUBLICA_DO', codigo: '736', descricao: 'AZERBAIJAO, REPUBLICA DO' },
	{ nome: 'BAHAMAS_ILHAS', codigo: '779', descricao: 'BAHAMAS, ILHAS' },
	{ nome: 'BAHREIN_ILHAS', codigo: '809', descricao: 'BAHREIN, ILHAS' },
	{ nome: 'BANGLADESH', codigo: '817', descricao: 'BANGLADESH' },
	{ nome: 'BARBADOS', codigo: '833', descricao: 'BARBADOS' },
	{ nome: 'BELARUS_REPUBLICA_DA', codigo: '850', descricao: 'BELARUS, REPUBLICA DA' },
	{ nome: 'BELGICA', codigo: '876', descricao: 'BELGICA' },
	{ nome: 'BELIZE', codigo: '884', descricao: 'BELIZE' },
	{ nome: 'BENIN', codigo: '2291', descricao: 'BENIN' },
	{ nome: 'BERMUDAS', codigo: '906', descricao: 'BERMUDAS' },
	{ nome: 'BOLIVIA_ESTADO_PLURINACIONAL_DA', codigo: '973', descricao: 'BOLIVIA, ESTADO PLURINACIONAL DA' },
	{ nome: 'BONAIRE', codigo: '990', descricao: 'BONAIRE' },
	{ nome: 'BOSNIA_HERZEGOVINA_REPUBLICA_DA', codigo: '981', descricao: 'BOSNIA-HERZEGOVINA (REPUBLICA DA)' },
	{ nome: 'BOTSUANA', codigo: '1015', descricao: 'BOTSUANA' },
	{ nome: 'BOUVET_ILHA', codigo: '1023', descricao: 'BOUVET, ILHA' },
	{ nome: 'BRASIL', codigo: '1058', descricao: 'BRASIL' },
	{ nome: 'BRUNEI', codigo: '1082', descricao: 'BRUNEI' },
	{ nome: 'BULGARIA_REPUBLICA_DA', codigo: '1112', descricao: 'BULGARIA, REPUBLICA DA' },
	{ nome: 'BURKINA_FASO', codigo: '310', descricao: 'BURKINA FASO' },
	{ nome: 'BURUNDI', codigo: '1155', descricao: 'BURUNDI' },
	{ nome: 'BUTAO', codigo: '1198', descricao: 'BUTAO' },
	{ nome: 'CABO_VERDE_REPUBLICA_DE', codigo: '1279', descricao: 'CABO VERDE, REPUBLICA DE' },
	{ nome: 'CAMAROES', codigo: '1457', descricao: 'CAMAROES' },
	{ nome: 'CAMBOJA', codigo: '1414', descricao: 'CAMBOJA' },
	{ nome: 'CANADA', codigo: '1490', descricao: 'CANADA' },
	{ nome: 'CATAR', codigo: '1546', descricao: 'CATAR' },
	{ nome: 'CAYMAN_ILHAS', codigo: '1376', descricao: 'CAYMAN, ILHAS' },
	{ nome: 'CAZAQUISTAO_REPUBLICA_DO', codigo: '1538', descricao: 'CAZAQUISTAO, REPUBLICA DO' },
	{ nome: 'CHADE', codigo: '7889', descricao: 'CHADE' },
	{ nome: 'CHILE', codigo: '1589', descricao: 'CHILE' },
	{ nome: 'CHINA_REPUBLICA_POPULAR', codigo: '1600', descricao: 'CHINA, REPUBLICA POPULAR' },
	{ nome: 'CHIPRE', codigo: '1635', descricao: 'CHIPRE' },
	{ nome: 'CHRISTMAS_ILHA_NAVIDAD', codigo: '5118', descricao: 'CHRISTMAS,ILHA (NAVIDAD)' },
	{ nome: 'CINGAPURA', codigo: '7412', descricao: 'CINGAPURA' },
	{ nome: 'COCOS_KEELING_ILHAS', codigo: '1651', descricao: 'COCOS(KEELING),ILHAS' },
	{ nome: 'COLOMBIA', codigo: '1694', descricao: 'COLOMBIA' },
	{ nome: 'COMORES_ILHAS', codigo: '1732', descricao: 'COMORES, ILHAS' },
	{ nome: 'CONGO', codigo: '1775', descricao: 'CONGO' },
	{ nome: 'CONGO_REPUBLICA_DEMOCRATICA_DO', codigo: '8885', descricao: 'CONGO, REPUBLICA DEMOCRATICA DO' },
	{ nome: 'COOK_ILHAS', codigo: '1830', descricao: 'COOK, ILHAS' },
	{ nome: 'COREIA_DO_NORTE__REP_POP_DEMOCRATICA', codigo: '1872', descricao: 'COREIA (DO NORTE), REP.POP.DEMOCRATICA' },
	{ nome: 'COREIA_DO_SUL__REPUBLICA_DA', codigo: '1902', descricao: 'COREIA (DO SUL), REPUBLICA DA' },
	{ nome: 'COSTA_DO_MARFIM', codigo: '1937', descricao: 'COSTA DO MARFIM' },
	{ nome: 'COSTA_RICA', codigo: '1961', descricao: 'COSTA RICA' },
	{ nome: 'CROACIA_REPUBLICA_DA', codigo: '1953', descricao: 'CROACIA (REPUBLICA DA)' },
	{ nome: 'CUBA', codigo: '1996', descricao: 'CUBA' },
	{ nome: 'CURACAO', codigo: '2003', descricao: 'CURACAO' },
	{ nome: 'DINAMARCA', codigo: '2321', descricao: 'DINAMARCA' },
	{ nome: 'DJIBUTI', codigo: '7838', descricao: 'DJIBUTI' },
	{ nome: 'DOMINICA_ILHA', codigo: '2356', descricao: 'DOMINICA,ILHA' },
	{ nome: 'EGITO', codigo: '2402', descricao: 'EGITO' },
	{ nome: 'EL_SALVADOR', codigo: '6874', descricao: 'EL SALVADOR' },
	{ nome: 'EMIRADOS_ARABES_UNIDOS', codigo: '2445', descricao: 'EMIRADOS ARABES UNIDOS' },
	{ nome: 'EQUADOR', codigo: '2399', descricao: 'EQUADOR' },
	{ nome: 'ERITREIA', codigo: '2437', descricao: 'ERITREIA' },
	{ nome: 'ESLOVACA_REPUBLICA', codigo: '2470', descricao: 'ESLOVACA, REPUBLICA' },
	{ nome: 'ESLOVENIA_REPUBLICA_DA', codigo: '2461', descricao: 'ESLOVENIA, REPUBLICA DA' },
	{ nome: 'ESPANHA', codigo: '2453', descricao: 'ESPANHA' },
	{ nome: 'ESTADOS_UNIDOS', codigo: '2496', descricao: 'ESTADOS UNIDOS' },
	{ nome: 'ESTONIA_REPUBLICA_DA', codigo: '2518', descricao: 'ESTONIA, REPUBLICA DA' },
	{ nome: 'ETIOPIA', codigo: '2534', descricao: 'ETIOPIA' },
	{ nome: 'FALKLAND_ILHAS_MALVINAS', codigo: '2550', descricao: 'FALKLAND (ILHAS MALVINAS)' },
	{ nome: 'FEROE_ILHAS', codigo: '2593', descricao: 'FEROE, ILHAS' },
	{ nome: 'FIJI', codigo: '8702', descricao: 'FIJI' },
	{ nome: 'FILIPINAS', codigo: '2674', descricao: 'FILIPINAS' },
	{ nome: 'FINLANDIA', codigo: '2712', descricao: 'FINLANDIA' },
	{ nome: 'FORMOSA_TAIWAN', codigo: '1619', descricao: 'FORMOSA (TAIWAN)' },
	{ nome: 'FRANCA', codigo: '2755', descricao: 'FRANCA' },
	{ nome: 'GABAO', codigo: '2810', descricao: 'GABAO' },
	{ nome: 'GAMBIA', codigo: '2852', descricao: 'GAMBIA' },
	{ nome: 'GANA', codigo: '2895', descricao: 'GANA' },
	{ nome: 'GEORGIA_REPUBLICA_DA', codigo: '2917', descricao: 'GEORGIA, REPUBLICA DA' },
	{ nome: 'GIBRALTAR', codigo: '2933', descricao: 'GIBRALTAR' },
	{ nome: 'GRANADA', codigo: '2976', descricao: 'GRANADA' },
	{ nome: 'GRECIA', codigo: '3018', descricao: 'GRECIA' },
	{ nome: 'GROENLANDIA', codigo: '3050', descricao: 'GROENLANDIA' },
	{ nome: 'GUADALUPE', codigo: '3093', descricao: 'GUADALUPE' },
	{ nome: 'GUAM', codigo: '3131', descricao: 'GUAM' },
	{ nome: 'GUATEMALA', codigo: '3174', descricao: 'GUATEMALA' },
	{ nome: 'GUERNSEY_ILHA_DO_CANAL_INCLUI_ALDERNEY_E_SARK', codigo: '3212', descricao: 'GUERNSEY, ILHA DO CANAL (INCLUI ALDERNEY E SARK)' },
	{ nome: 'GUIANA', codigo: '3379', descricao: 'GUIANA' },
	{ nome: 'GUIANA_FRANCESA', codigo: '3255', descricao: 'GUIANA FRANCESA' },
	{ nome: 'GUINE', codigo: '3298', descricao: 'GUINE' },
	{ nome: 'GUINE_BISSAU', codigo: '3344', descricao: 'GUINE-BISSAU' },
	{ nome: 'GUINE_EQUATORIAL', codigo: '3310', descricao: 'GUINE-EQUATORIAL' },
	{ nome: 'HAITI', codigo: '3417', descricao: 'HAITI' },
	{ nome: 'HONDURAS', codigo: '3450', descricao: 'HONDURAS' },
	{ nome: 'HONG_KONG', codigo: '3514', descricao: 'HONG KONG' },
	{ nome: 'HUNGRIA_REPUBLICA_DA', codigo: '3557', descricao: 'HUNGRIA, REPUBLICA DA' },
	{ nome: 'IEMEN', codigo: '3573', descricao: 'IEMEN' },
	{ nome: 'ILHA_HEARD_E_ILHAS_MCDONALD', codigo: '3433', descricao: 'ILHA HEARD E ILHAS MCDONALD' },
	{ nome: 'ILHAS_DE_SAO_MARTINHO_PARTE_FRANCESA', codigo: '6980', descricao: 'ILHAS DE SAO MARTINHO (PARTE FRANCESA)' },
	{ nome: 'ILHAS_GEORGIA_DO_SUL_E_SANDWICH_DO_SUL', codigo: '2925', descricao: 'ILHAS GEORGIA DO SUL E SANDWICH DO SUL' },
	{ nome: 'INDIA', codigo: '3611', descricao: 'INDIA' },
	{ nome: 'INDONESIA', codigo: '3654', descricao: 'INDONESIA' },
	{ nome: 'IRA_REPUBLICA_ISLAMICA_DO', codigo: '3727', descricao: 'IRA, REPUBLICA ISLAMICA DO' },
	{ nome: 'IRAQUE', codigo: '3697', descricao: 'IRAQUE' },
	{ nome: 'IRLANDA', codigo: '3751', descricao: 'IRLANDA' },
	{ nome: 'ISLANDIA', codigo: '3794', descricao: 'ISLANDIA' },
	{ nome: 'ISRAEL', codigo: '3832', descricao: 'ISRAEL' },
	{ nome: 'ITALIA', codigo: '3867', descricao: 'ITALIA' },
	{ nome: 'JAMAICA', codigo: '3913', descricao: 'JAMAICA' },
	{ nome: 'JAPAO', codigo: '3999', descricao: 'JAPAO' },
	{ nome: 'JERSEY_ILHA_DO_CANAL', codigo: '3930', descricao: 'JERSEY, ILHA DO CANAL' },
	{ nome: 'JOHNSTON_ILHAS', codigo: '3964', descricao: 'JOHNSTON, ILHAS' },
	{ nome: 'JORDANIA', codigo: '4030', descricao: 'JORDANIA' },
	{ nome: 'KIRIBATI', codigo: '4111', descricao: 'KIRIBATI' },
	{ nome: 'KUWAIT', codigo: '1988', descricao: 'KUWAIT' },
	{ nome: 'LAOS_REP_POP_DEMOCR_DO', codigo: '4200', descricao: 'LAOS, REP.POP.DEMOCR.DO' },
	{ nome: 'LEBUAN_ILHAS', codigo: '4235', descricao: 'LEBUAN,ILHAS' },
	{ nome: 'LESOTO', codigo: '4260', descricao: 'LESOTO' },
	{ nome: 'LETONIA_REPUBLICA_DA', codigo: '4278', descricao: 'LETONIA, REPUBLICA DA' },
	{ nome: 'LIBANO', codigo: '4316', descricao: 'LIBANO' },
	{ nome: 'LIBERIA', codigo: '4340', descricao: 'LIBERIA' },
	{ nome: 'LIBIA', codigo: '4383', descricao: 'LIBIA' },
	{ nome: 'LIECHTENSTEIN', codigo: '4405', descricao: 'LIECHTENSTEIN' },
	{ nome: 'LITUANIA_REPUBLICA_DA', codigo: '4421', descricao: 'LITUANIA, REPUBLICA DA' },
	{ nome: 'LUXEMBURGO', codigo: '4456', descricao: 'LUXEMBURGO' },
	{ nome: 'MACAU', codigo: '4472', descricao: 'MACAU' },
	{ nome: 'MACEDONIA_ANT_REP_IUGOSLAVA', codigo: '4499', descricao: 'MACEDONIA, ANT.REP.IUGOSLAVA' },
	{ nome: 'MADAGASCAR', codigo: '4502', descricao: 'MADAGASCAR' },
	{ nome: 'MADEIRA_ILHA_DA', codigo: '4525', descricao: 'MADEIRA, ILHA DA' },
	{ nome: 'MALASIA', codigo: '4553', descricao: 'MALASIA' },
	{ nome: 'MALAVI', codigo: '4588', descricao: 'MALAVI' },
	{ nome: 'MALDIVAS', codigo: '4618', descricao: 'MALDIVAS' },
	{ nome: 'MALI', codigo: '4642', descricao: 'MALI' },
	{ nome: 'MALTA', codigo: '4677', descricao: 'MALTA' },
	{ nome: 'MAN_ILHA_DE', codigo: '3595', descricao: 'MAN, ILHA DE' },
	{ nome: 'MARIANAS_DO_NORTE', codigo: '4723', descricao: 'MARIANAS DO NORTE' },
	{ nome: 'MARROCOS', codigo: '4740', descricao: 'MARROCOS' },
	{ nome: 'MARSHALL_ILHAS', codigo: '4766', descricao: 'MARSHALL,ILHAS' },
	{ nome: 'MARTINICA', codigo: '4774', descricao: 'MARTINICA' },
	{ nome: 'MAURICIO', codigo: '4855', descricao: 'MAURICIO' },
	{ nome: 'MAURITANIA', codigo: '4880', descricao: 'MAURITANIA' },
	{ nome: 'MAYOTTE_ILHAS_FRANCESAS', codigo: '4898', descricao: 'MAYOTTE (ILHAS FRANCESAS)' },
	{ nome: 'MEXICO', codigo: '4936', descricao: 'MEXICO' },
	{ nome: 'MIANMAR_BIRMANIA', codigo: '930', descricao: 'MIANMAR (BIRMANIA)' },
	{ nome: 'MICRONESIA', codigo: '4995', descricao: 'MICRONESIA' },
	{ nome: 'MIDWAY_ILHAS', codigo: '4901', descricao: 'MIDWAY, ILHAS' },
	{ nome: 'MOCAMBIQUE', codigo: '5053', descricao: 'MOCAMBIQUE' },
	{ nome: 'MOLDAVIA_REPUBLICA_DA', codigo: '4944', descricao: 'MOLDAVIA, REPUBLICA DA' },
	{ nome: 'MONACO', codigo: '4952', descricao: 'MONACO' },
	{ nome: 'MONGOLIA', codigo: '4979', descricao: 'MONGOLIA' },
	{ nome: 'MONTENEGRO', codigo: '4985', descricao: 'MONTENEGRO' },
	{ nome: 'MONTSERRAT_ILHAS', codigo: '5010', descricao: 'MONTSERRAT,ILHAS' },
	{ nome: 'NAMIBIA', codigo: '5070', descricao: 'NAMIBIA' },
	{ nome: 'NAURU', codigo: '5088', descricao: 'NAURU' },
	{ nome: 'NEPAL', codigo: '5177', descricao: 'NEPAL' },
	{ nome: 'NICARAGUA', codigo: '5215', descricao: 'NICARAGUA' },
	{ nome: 'NIGER', codigo: '5258', descricao: 'NIGER' },
	{ nome: 'NIGERIA', codigo: '5282', descricao: 'NIGERIA' },
	{ nome: 'NIUE_ILHA', codigo: '5312', descricao: 'NIUE,ILHA' },
	{ nome: 'NORFOLK_ILHA', codigo: '5355', descricao: 'NORFOLK,ILHA' },
	{ nome: 'NORUEGA', codigo: '5380', descricao: 'NORUEGA' },
	{ nome: 'NOVA_CALEDONIA', codigo: '5428', descricao: 'NOVA CALEDONIA' },
	{ nome: 'NOVA_ZELANDIA', codigo: '5487', descricao: 'NOVA ZELANDIA' },
	{ nome: 'OMA', codigo: '5568', descricao: 'OMA' },
	{ nome: 'PACIFICO_ILHAS_DO_POSSESSAO_DOS_EUA', codigo: '5665', descricao: 'PACIFICO,ILHAS DO (POSSESSAO DOS EUA)' },
	{ nome: 'PAISES_BAIXOS_HOLANDA', codigo: '5738', descricao: 'PAISES BAIXOS (HOLANDA)' },
	{ nome: 'PALAU', codigo: '5754', descricao: 'PALAU' },
	{ nome: 'PALESTINA', codigo: '5780', descricao: 'PALESTINA' },
	{ nome: 'PANAMA', codigo: '5800', descricao: 'PANAMA' },
	{ nome: 'PAPUA_NOVA_GUINE', codigo: '5452', descricao: 'PAPUA NOVA GUINE' },
	{ nome: 'PAQUISTAO', codigo: '5762', descricao: 'PAQUISTAO' },
	{ nome: 'PARAGUAI', codigo: '5860', descricao: 'PARAGUAI' },
	{ nome: 'PERU', codigo: '5894', descricao: 'PERU' },
	{ nome: 'PITCAIRN_ILHA', codigo: '5932', descricao: 'PITCAIRN,ILHA' },
	{ nome: 'POLINESIA_FRANCESA', codigo: '5991', descricao: 'POLINESIA FRANCESA' },
	{ nome: 'POLONIA_REPUBLICA_DA', codigo: '6033', descricao: 'POLONIA, REPUBLICA DA' },
	{ nome: 'PORTO_RICO', codigo: '6114', descricao: 'PORTO RICO' },
	{ nome: 'PORTUGAL', codigo: '6076', descricao: 'PORTUGAL' },
	{ nome: 'QUENIA', codigo: '6238', descricao: 'QUENIA' },
	{ nome: 'QUIRGUIZ_REPUBLICA', codigo: '6254', descricao: 'QUIRGUIZ, REPUBLICA' },
	{ nome: 'REINO_UNIDO', codigo: '6289', descricao: 'REINO UNIDO' },
	{ nome: 'REPUBLICA_CENTRO_AFRICANA', codigo: '6408', descricao: 'REPUBLICA CENTRO-AFRICANA' },
	{ nome: 'REPUBLICA_DOMINICANA', codigo: '6475', descricao: 'REPUBLICA DOMINICANA' },
	{ nome: 'REUNIAO_ILHA', codigo: '6602', descricao: 'REUNIAO, ILHA' },
	{ nome: 'ROMENIA', codigo: '6700', descricao: 'ROMENIA' },
	{ nome: 'RUANDA', codigo: '6750', descricao: 'RUANDA' },
	{ nome: 'RUSSIA_FEDERACAO_DA', codigo: '6769', descricao: 'RUSSIA, FEDERACAO DA' },
	{ nome: 'SAARA_OCIDENTAL', codigo: '6858', descricao: 'SAARA OCIDENTAL' },
	{ nome: 'SALOMAO_ILHAS', codigo: '6777', descricao: 'SALOMAO, ILHAS' },
	{ nome: 'SAMOA', codigo: '6904', descricao: 'SAMOA' },
	{ nome: 'SAMOA_AMERICANA', codigo: '6912', descricao: 'SAMOA AMERICANA' },
	{ nome: 'SAN_MARINO', codigo: '6971', descricao: 'SAN MARINO' },
	{ nome: 'SANTA_HELENA', codigo: '7102', descricao: 'SANTA HELENA' },
	{ nome: 'SANTA_LUCIA', codigo: '7153', descricao: 'SANTA LUCIA' },
	{ nome: 'SAO_BARTOLOMEU', codigo: '6939', descricao: 'SAO BARTOLOMEU' },
	{ nome: 'SAO_CRISTOVAO_E_NEVES_ILHAS', codigo: '6955', descricao: 'SAO CRISTOVAO E NEVES,ILHAS' },
	{ nome: 'SAO_MARTINHO_ILHA_DE_PARTE_FRANCESA', codigo: '6998', descricao: 'SAO MARTINHO, ILHA DE (PARTE FRANCESA)' },
	{ nome: 'SAO_PEDRO_E_MIQUELON', codigo: '7005', descricao: 'SAO PEDRO E MIQUELON' },
	{ nome: 'SAO_TOME_E_PRINCIPE_ILHAS', codigo: '7200', descricao: 'SAO TOME E PRINCIPE, ILHAS' },
	{ nome: 'SAO_VICENTE_E_GRANADINAS', codigo: '7056', descricao: 'SAO VICENTE E GRANADINAS' },
	{ nome: 'SENEGAL', codigo: '7285', descricao: 'SENEGAL' },
	{ nome: 'SERRA_LEOA', codigo: '7358', descricao: 'SERRA LEOA' },
	{ nome: 'SERVIA', codigo: '7370', descricao: 'SERVIA' },
	{ nome: 'SEYCHELLES', codigo: '7315', descricao: 'SEYCHELLES' },
	{ nome: 'SIRIA_REPUBLICA_ARABE_DA', codigo: '7447', descricao: 'SIRIA, REPUBLICA ARABE DA' },
	{ nome: 'SOMALIA', codigo: '7480', descricao: 'SOMALIA' },
	{ nome: 'SRI_LANKA', codigo: '7501', descricao: 'SRI LANKA' },
	{ nome: 'SUAZILANDIA', codigo: '7544', descricao: 'SUAZILANDIA' },
	{ nome: 'SUDAO', codigo: '7595', descricao: 'SUDAO' },
	{ nome: 'SUD_O_DO_SUL', codigo: '7600', descricao: 'SUDÃO DO SUL' },
	{ nome: 'SUECIA', codigo: '7641', descricao: 'SUECIA' },
	{ nome: 'SUICA', codigo: '7676', descricao: 'SUICA' },
	{ nome: 'SURINAME', codigo: '7706', descricao: 'SURINAME' },
	{ nome: 'SVALBARD_E_JAN_MAYERN', codigo: '7552', descricao: 'SVALBARD E JAN MAYERN' },
	{ nome: 'TADJIQUISTAO_REPUBLICA_DO', codigo: '7722', descricao: 'TADJIQUISTAO, REPUBLICA DO' },
	{ nome: 'TAILANDIA', codigo: '7765', descricao: 'TAILANDIA' },
	{ nome: 'TANZANIA_REP_UNIDA_DA', codigo: '7803', descricao: 'TANZANIA, REP.UNIDA DA' },
	{ nome: 'TCHECA_REPUBLICA', codigo: '7919', descricao: 'TCHECA, REPUBLICA' },
	{ nome: 'TERRAS_AUSTRAIS_E_ANTARTICAS_FRANCESAS', codigo: '7811', descricao: 'TERRAS AUSTRAIS E ANTARTICAS FRANCESAS' },
	{ nome: 'TERRITORIO_BRIT_OC_INDICO', codigo: '7820', descricao: 'TERRITORIO BRIT.OC.INDICO' },
	{ nome: 'TIMOR_LESTE', codigo: '7951', descricao: 'TIMOR LESTE' },
	{ nome: 'TOGO', codigo: '8001', descricao: 'TOGO' },
	{ nome: 'TONGA', codigo: '8109', descricao: 'TONGA' },
	{ nome: 'TOQUELAU_ILHAS', codigo: '8052', descricao: 'TOQUELAU,ILHAS' },
	{ nome: 'TRINIDAD_E_TOBAGO', codigo: '8150', descricao: 'TRINIDAD E TOBAGO' },
	{ nome: 'TUNISIA', codigo: '8206', descricao: 'TUNISIA' },
	{ nome: 'TURCAS_E_CAICOS_ILHAS', codigo: '8230', descricao: 'TURCAS E CAICOS,ILHAS' },
	{ nome: 'TURCOMENISTAO_REPUBLICA_DO', codigo: '8249', descricao: 'TURCOMENISTAO, REPUBLICA DO' },
	{ nome: 'TURQUIA', codigo: '8273', descricao: 'TURQUIA' },
	{ nome: 'TUVALU', codigo: '8281', descricao: 'TUVALU' },
	{ nome: 'UCRANIA', codigo: '8311', descricao: 'UCRANIA' },
	{ nome: 'UGANDA', codigo: '8338', descricao: 'UGANDA' },
	{ nome: 'URUGUAI', codigo: '8451', descricao: 'URUGUAI' },
	{ nome: 'UZBEQUISTAO_REPUBLICA_DO', codigo: '8478', descricao: 'UZBEQUISTAO, REPUBLICA DO' },
	{ nome: 'VANUATU', codigo: '5517', descricao: 'VANUATU' },
	{ nome: 'VATICANO_EST_DA_CIDADE_DO', codigo: '8486', descricao: 'VATICANO, EST.DA CIDADE DO' },
	{ nome: 'VENEZUELA', codigo: '8508', descricao: 'VENEZUELA' },
	{ nome: 'VIETNA', codigo: '8583', descricao: 'VIETNA' },
	{ nome: 'VIRGENS_ILHAS_BRITANICAS', codigo: '8630', descricao: 'VIRGENS,ILHAS (BRITANICAS)' },
	{ nome: 'VIRGENS_ILHAS_E_U_A', codigo: '8664', descricao: 'VIRGENS,ILHAS (E.U.A.)' },
	{ nome: 'WAKE_ILHA', codigo: '8737', descricao: 'WAKE, ILHA' },
	{ nome: 'WALLIS_E_FUTUNA_ILHAS', codigo: '8753', descricao: 'WALLIS E FUTUNA, ILHAS' },
	{ nome: 'ZAMBIA', codigo: '8907', descricao: 'ZAMBIA' },
	{ nome: 'ZIMBABUE', codigo: '6653', descricao: 'ZIMBABUE' },
]

export default paises
